export const categoryList = [
  {
    id: 1,
    value: "male",
    label: "Male Doc",
  },
  {
    id: 2,
    value: "female",
    label: "Female Doc",
  },
];

export const doctorJson = [
  {
    id: 1,
    title: "Mazhar Bukhari",
    image: "/images/doc2.png",
    profession: "ENT",
    description: "Gujranwala Medical College, Satellite town Pasrur Road",
    location: "Gujranwala 52250",
    experience: "3 Years",
    date: "Wed, Fri, Sat",
    category: "male",
    cuisine: "ent",
    price: "5",
  },
  {
    id: 2,
    title: "Anabia Khurram",
    image: "/images/doc1.png",
    profession: "Gynecologist",
    description: "Allama Shabbir Ahmed Usmani Road",
    location: "Lahore 54550",
    experience: "1 Year to 2 Years",
    date: "Mon, Thu, Wed, Sat",
    category: "female",
    cuisine: "gynecologist",
    price: "1",
  },
  {
    id: 3,
    image: "/images/doc3.png",
    title: "Fish Marie",
    profession: "Gynecologist",
    description: "Sheikh Zayed Medical Complex, Khayaban-e-Jamia Punjab",
    location: "Lahore, Pakistan",
    experience: "1 Year to 2 Years",
    price: "4",
    date: "Thu, Wed, Sat",
    category: "female",
    cuisine: "gynecologist",
  },
  {
    id: 4,
    image: "/images/doc4.png",
    title: "Talha Anees",
    profession: "ENT",
    description: "Khawaja Muhammad Safdar Medical College",
    location: "Sialkot",
    experience: "1 Year to 3 Years",
    price: "6",
    date: "Mon, Wed, Sat",
    category: "male",
    cuisine: "ent",
  },
  {
    id: 5,
    image: "/images/doc1.png",
    title: "Saleena Gomez",
    profession: "Cardiologist",
    description: "Allama Shabbir Ahmed Usmani Road",
    location: "Lahore 54550",
    experience: "1 Year to 3 Years",
    date: "Mon, Fri, Sat",
    price: "8",
    category: "female",
    cuisine: "cardiologist",
  },
  {
    id: 6,
    image: "/images/doc3.png",
    title: "Bella Stone",
    profession: "Urologist",
    description: "Punjab Medical College",
    location: "Faisalabad",
    experience: "7 Years to 10 Years",
    price: "10",
    date: "Mon, Fri, Sat, Sun",
    category: "female",
    title: "lounge resort",
    cuisine: "urologist",
  },
  {
    id: 7,
    image: "/images/doc3.png",
    title: "Bella Stone",
    profession: "Urologist",
    description: "Punjab Medical College",
    location: "Faisalabad",
    experience: "7 Years to 10 Years",
    price: "10",
    date: "Mon, Fri, Sat, Sun",
    category: "female",
    title: "lounge resort",
    cuisine: "urologist",
  },
  {
    id: 8,
    image: "/images/doc3.png",
    title: "Bella Stone",
    profession: "Urologist",
    description: "Punjab Medical College",
    location: "Faisalabad",
    experience: "7 Years to 10 Years",
    price: "10",
    date: "Mon, Fri, Sat, Sun",
    category: "female",
    title: "lounge resort",
    cuisine: "urologist",
  },
];
